import { PromotionMetadata } from "@/store/types/order";

export function isEndlessPromotion(validityPeriod: string): boolean {
  return validityPeriod === "endless";
}

export function getPromotionMonthCount(
  validityPeriod: string,
  bindingPeriod: number
): number {
  if (isEndlessPromotion(validityPeriod)) return bindingPeriod;
  if (validityPeriod === "1_month") return 1;
  const parsed = parseInt(validityPeriod, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

export function parsePromotion(
  promotionData: PromotionMetadata | string | undefined
): PromotionMetadata | undefined {
  if (!promotionData) return undefined;
  if (typeof promotionData === "string") {
    try {
      return JSON.parse(promotionData) as PromotionMetadata;
    } catch {
      return undefined;
    }
  }
  return promotionData;
}
